import CrudRepository from './CrudRepository'
export default class SocialResponsibilitySliderRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/socialResponsibility/web/category')
  }
}
